<template>
  <div class="user-list">
    <div v-if="!hideFilters" class="page-container user-list-header">
      <div class="user-list-header__head">
        <div class="user-list-header__label">
          {{ $t('labels.filters_and_actions') }}
        </div>
        <div class="user-list-header__head-buttons">
          <el-button v-if="showClearSearch" icon="el-icon-close" class="user-list-search__clear" @click="clearSearch">
            {{ $t('labels.clear_search_and_filter') }}
          </el-button>
          <div class="user-list-search">
            <el-popover
              trigger="click"
              v-model="showSearchInputs">
              <div class="user-list-search__wrapp">
                <div class="user-list-search__label">
                  {{ $t('labels.search_employee_by_fields') }}
                </div>
                <div class="user-list-search__inputs">
                  <div class="el-input el-input--medium">
                    <input
                      type="text"
                      class="el-input__inner"
                      :placeholder="$t('labels.surname')"
                      v-model="query.last_name"
                      @keyup.enter="loadList"
                      ref='searchFirstInput'
                    >
                  </div>
                  <div class="el-input el-input--medium">
                    <input
                      type="text"
                      class="el-input__inner"
                      :placeholder="$t('labels.name')"
                      v-model="query.first_name"
                      @keyup.enter="loadList"
                    >
                  </div>
                  <div class="el-input el-input--medium">
                    <input
                      type="text"
                      class="el-input__inner"
                      :placeholder="$t('labels.middle_name')"
                      v-model="query.middle_name"
                      @keyup.enter="loadList"
                    >
                  </div>
                  <div class="el-input el-input--medium">
                    <input
                      type="text"
                      class="el-input__inner"
                      placeholder="Email"
                      v-model="query.email"
                      @keyup.enter="loadList"
                    >
                  </div>
                  <div class="el-input el-input--medium">
                    <input
                      type="text"
                      class="el-input__inner"
                      :placeholder="$t('labels.phone')"
                      v-model="query.phone"
                      @keyup.enter="loadList"
                    >
                  </div>
                  <div class="el-input el-input--medium">
                    <input
                      type="text"
                      class="el-input__inner"
                      :placeholder="$t('labels.login')"
                      v-model="query.login"
                      @keyup.enter="loadList"
                    >
                  </div>
                </div>
                <div class="user-list-search__button">
                  <el-button type="primary" size="medium" @click="loadList">{{ $t('labels.search') }}</el-button>
                  <el-button size="medium" @click="clearQuery">{{ $t('labels.clear') }}</el-button>
                  <div @click="showSearchInputs = false"
                       class="user-list-search__cancel">{{ $t('labels.cancel') }}
                  </div>
                </div>
              </div>
              <el-button slot="reference" icon="el-icon-search">{{ $t('labels.search_employee') }}</el-button>
            </el-popover>
          </div>
          <router-link v-if="admin" to="/users/create"
                       class="el-button el-button--primary el-button--medium user-list-search__create">
            <i class="el-icon-circle-plus-outline"></i>
            <span>{{ $t('employees.create') }}</span>
          </router-link>
        </div>
      </div>
      <user-list-filters ref="filters" @changed="loadList"></user-list-filters>
    </div>
    <pagination :documents-name="$t('labels.employees1')"
                :count="userList.length"
                :pagination="pagination"
                :paginationPage="paginationPage"
                @size-change="onPaginationPageSizeChange"
                @current-change="onPaginationCurrentChange"></pagination>
    <user-table
      :emptyText="$t('labels.not_founded')"
      :loadingUsers="loadingUsers"
      :data="userList"
      @sort-change="onSortChange"
      @row-click="onTableRowClick"
      :index-offset="pagination.pageSize * (pagination.currentPage - 1)"
      :short-mode="shortMode"
    ></user-table>
    <pagination :count="count"
                :pagination="pagination"
                @size-change="onPaginationPageSizeChange"
                @current-change="onPaginationCurrentChange"></pagination>
  </div>
</template>
<script>
  import _ from 'lodash'
  import moment from 'moment'
  import 'moment/locale/ru';
  // import listAgrerator from 'src/services/userList'
  import Pagination from '@/components/Ui/Pagination/Pagination';
  import UserListFilters from './ListFilters';
  import UserTable from './UserTable';
  import {mapState} from 'vuex';
  import {USER_ROLE_ADMIN} from '@/constants'
  import {normPhone} from '@/lib/phone'
  import {lang} from '@/lang/index'

  const emptyQuery = {
    first_name: undefined,
    last_name: undefined,
    middle_name: undefined,
    email: undefined,
    phone: undefined,
    login: undefined
  }

  export default {
    props: {
      pageBaseUrl: {
        type: String,
        required: true
      },
      orgId: {
        default: false
      },
      hideFilters: {
        type: Boolean,
        default: false
      },
      shortMode: {
        type: Boolean,
        default: false
      }
    },
    components: {
      UserTable,
      UserListFilters,
      Pagination
    },
    data() {
      return {
        loadingUsers: false,
        userList: [],
        count: null,
        query: _.clone(emptyQuery),
        order: {
          prop: 'last_name',
          order: 'ascending'
        },
        sort: [],
        filters: {
          workStatus: [
            {
              value: 'active',
              label: this.$t('employees.work_status.active')
            }, {
              value: 'closed',
              label: this.$t('employees.work_status.closed')
            }
          ],
          onlineStatus: [
            {
              value: 'online',
              label: 'Online'
            }, {
              value: 'offline',
              label: 'Offline'
            }
          ]
        },
        showSearchInputs: false,
        showClearSearch: false,
        pagination: {
          pageSize: 10,
          currentPage: +(this.$route.params.page || 1),
          totalItems: 100000
        },
        paginationPage: +this.$route.params.page || 1,
        columnNames: ['№', this.$t('labels.surname'), this.$t('labels.name'), this.$t('labels.middle_name'), this.$t('labels.position'), this.$t('labels.cols.status'), this.$t('labels.last_activity')]
      };
    },
    computed: {
      user () {
        return this.$store.state.user.user
      },
      admin () {
        if (this.$store.state.user.user) {
          return this.$store.state.user.user.checkRole(USER_ROLE_ADMIN)
        }
        return false
      }
    },
    methods: {
      onSortChange(event) {
        this.sort = []
        if (event.length) {
          this.sort.push(event)
        }
        this.loadList()
      },
      setSearchFocus() {
        this.$refs.searchFirstInput.focus()
      },
      onTableRowClick(row, event, column) {
        if (this.columnNames.indexOf(column.label) > 0) {
          if (row.getId() !== this.user.getId()) {
            this.$router.push({name: 'user', params: {id: row.getId()}});
          } else {
            this.$router.push({name: 'profilePage'});
          }
        }
      },
      async loadList(query, filter, order) {
        try {
          this.loadingUsers = true
          let filters = {}
          if (this.$refs.filters) {
            filters = this.$refs.filters.getFilters()
          }
          let query = _.cloneDeep(this.query)
          let emptyKeys = []
          for (let key in query) {
            if (!query[key]) {
              emptyKeys.push(key)
            }
          }
          if (query.phone) {
            query.phone = normPhone(query.phone)
          }
          if (query.phone && query.phone[0] === '8') {
            query.phone = query.phone.slice(1)
          }
          for (let key of emptyKeys) {
            delete query[key]
          }
          let response = await this.$store.dispatch('users/findUsers',
            {
              limit: this.pagination.pageSize,
              offset: this.pagination.pageSize * (this.pagination.currentPage - 1),
              ...query,
              ...filters,
              sort: this.sort
            });
          this.loadingUsers = false
          this.userList = response.users;
          this.count = response.count;
          this.pagination.totalItems = response.count;
        } catch (error) {
          console.error('Load user list ERROR', error)
          this.$notify({
            // @ts-ignore
            title: this.$t('labels.error'),
            // @ts-ignore
            message: this.$t('labels.can_not_load_users'),
            type: 'error',
            offset: 75,
            duration: 2000
          });
          this.loadingUsers = false
        }
      },
      search() {
        /* this.showSearchInputs = false;
        let filters = {}
        if (this.$refs.filters) {
          filters = this.$refs.filters.getFilters()
        }
        let query = {}
        for (let col in this.query) {
          if (this.query[col] && this.query[col].trim() !== '') {
            query[col] = this.query[col].trim()
          }
        }
        if (this.orgId) {
          if (!filters['orgs.org_id']) {
            filters['orgs.org_id'] = [this.orgId]
          }
          filters['orgs.org_id'].push(this.orgId)
        }

        let order = false
        if (this.order.prop) {
          order = {[this.order.prop]: this.order.order === 'ascending' ? 'asc' : 'desc'}
        }

        this.showClearSearch = _.size(filters) > 0 || _.size(query) > 0

        this.loadList(query, filters, order); */
      },
      clearSearch() {
        this.clearQuery()
        this.$refs.filters.reset()
        this.showClearSearch = false;
        this.loadList();
      },
      clearQuery() {
        this.$set(this, 'query', _.clone(emptyQuery))
        this.loadList();
      },
      onPaginationPageSizeChange(size) {
        this.pagination.currentPage = +(this.$route.params.page || 1)
        this.pagination.pageSize = size;
        this.loadList();
      },
      onPaginationCurrentChange(currentPage) {
        this.$router.push(`${this.pageBaseUrl}/page/${currentPage}`)
        this.pagination.currentPage = currentPage;
        this.loadList();
      }
    },
    mounted() {
      this.loadList();
      this.search();
    },
    watch: {
      showSearchInputs: function (newQuestion) {
        let self = this;
        if (newQuestion) {
          setTimeout(function () {
            self.setSearchFocus()
          }, 10)
        }
      },
      $route (to,from) {
        this.pagination.currentPage = +this.$route.params.page || 1
        this.paginationPage = +this.$route.params.page || 1

        this.loadList();
      }
    },
    filters: {
      dateFormatFilter: function (value) {
        if (!value) return ''
        value = value.toString()
        return moment(String(value)).locale(lang).format('DD MMM YYYY HH:MM')
      }
    }
  }
</script>
<style lang="scss">
  @import 'src/assets/sass/core';

  .user-list-header {
    margin-bottom: 28px;

    &__head {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      padding: 0 25px 25px 25px;
      margin: 0 -25px;
      border-bottom: 1px solid $light-border-color;

      @include respond-to (tablet) {
        display: block;
      }
    }

    &__label {
      font-size: 20px;
      font-weight: 700;
      color: #000;

      @media (max-width: $screen-lg) {
        margin-bottom: 15px;
      }
    }
  }

  .user-list-search {
    position: relative;
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 10px;
    @media (max-width: $screen-sm) {
      display: block;
      width: 100%;
    }

    .el-popover__reference {
      @media (max-width: $screen-sm) {
        display: block;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    &__wrapp {
      max-width: 400px;
    }

    &__label {
      margin-bottom: 15px;
      font-size: 16px;
      font-weight: 700;
    }

    &__inputs {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 15px;
      grid-row-gap: 15px;
      margin-bottom: 20px;

      @media (max-width: $screen-sm) {
        grid-template-columns: 1fr;
      }
    }

    &__button {
      text-align: right;
      @media (max-width: $screen-sm) {
        display: block;
        width: 100%;
      }
    }

    &__cancel {
      display: none;
      margin-left: 10px;
      color: $link-color;
      @media (max-width: $screen-sm) {
        display: inline-block;
      }
    }

    &__clear {
      margin-bottom: 10px;
      margin-right: 10px;
      border: 0;
      @media (max-width: $screen-sm) {
        display: block;
        width: 100%;
        margin-right: 0;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    &__create {
      @media (max-width: $screen-sm) {
        display: block;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  .user-list-department {
    margin-bottom: 30px;

    &__title {
      font-size: 24px;
      margin-bottom: 20px;
    }

    &__tree-label {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }

  .user-list-table {
    border-radius: $global-radius;
    overflow: hidden;
    margin-bottom: 12px;

    .el-table {
      th {
        padding: 18px 0;

        .cell {
          font-size: 14px;
          font-weight: 400;
          color: #909399;
        }
      }

      th:first-child .cell {
        padding-left: 25px;
      }

      th:last-child .cell {
        padding-right: 25px;
      }
    }

    .el-table__row {
      cursor: pointer;

      td:first-child {
        padding-left: 25px;
      }

      td:last-child {
        padding-right: 25px;
      }
    }

    .cell {
      word-break: break-word;
      color: #000;
      padding-left: 5px;
      padding-right: 5px;

      .hasNotPost {
        color: #cecece;
      }
    }

    .el-table__expanded-cell[class*=cell] {
      padding: 0;
    }
  }
</style>